module.exports = __webpack_public_path__ + "assets/img/00161.96001d5e.png";